import { Image, Flex, Text, Divider } from '@chakra-ui/react'
import { Button as UbiButton } from '@ubirider/pick-component-library'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

import downloadIcon from '../../../../../../../../assets/download.svg'
import { userTimezone } from '../../../../../../../../App'

export default function Validation({ validation }) {
  const { t } = useTranslation()

  const inputDate = validation?.date
    ? DateTime.fromMillis(validation?.date * 1000, {
      zone: 'utc',
    })
      .setZone(userTimezone)
      .toFormat('dd/MM/yyyy HH:mm')
    : '-'

  return (
    <Flex flex='1' gap='8px'>
      <Flex flex='2' align='center'>
        <Text fontSize='13px' fontWeight='600'>
          {inputDate}
        </Text>
      </Flex>
      <Flex flex='2' align='center'>
        <Text fontSize='13px' fontWeight='600'>
          {validation.stop}
        </Text>
      </Flex>
      <Flex flex='2' align='center' justify={{ sm: 'flex-end', lg: 'flex-start' }}>
          <Text
            fontSize='13px'
            fontWeight='600'
            textTransform='uppercase'
            color={validation.status === 1 ? '#067F5B' : '#D23636'}
          >
            {t(validation?.status ? 'acqua_vias.last_trips_validation_status_label_valid' : 'acqua_vias.last_trips_validation_status_label_invalid')}
          </Text>
      </Flex>
    </Flex>
  )
}
